import { createClient } from '@supabase/supabase-js';
// console.log(`ENV: ${JSON.stringify(process.env)}`);
export const instanceUrl = process.env.REACT_APP_SUPABASE_INSTANCE_URL;
export const apiKey = process.env.REACT_APP_SUPABASE_API_KEY;
export const supabaseClient = createClient(instanceUrl, apiKey);
supabaseClient.SITE_URL = process.env.REACT_APP_PUBLIC_URL;